import { FieldWrapper, TitleInfo, Switch } from '~/components'
import * as styles from './index.module.css'

export default function CheckboxField({ field, form, title, info, reverseLayout, alternateBackground, children, ...props }) {
  const isChecked = field.value
  const isDisabled = props.disabled
  return (
    <FieldWrapper reverseLayout={reverseLayout} alternateBackground={alternateBackground} isDisabled={isDisabled}>
      <div className={styles.content}>
        <TitleInfo title={title} info={info} />
        {children}
      </div>
      <Switch 
        isChecked={isChecked}
        name={field.name} 
        form={form}
        onChange={field.onChange} 
        onBlur={field.onBlur} 
        {...props} 
      />
    </FieldWrapper>
  )
}
